import styled, { keyframes } from "styled-components";
import { Trans } from "../providers/TranslationProvider";

// Create the keyframes
const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

interface OuterProps {
	size?: number;
}

interface InnerProps {
	size?: number;
	color?: string;
}

const Outer = styled.div<OuterProps>`
	display: inline-block;
	position: relative;
	width: ${(props) => props.size || 58}px;
	height: ${(props) => props.size || 58}px;
`;

const Inner = styled.div<InnerProps>`
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: ${(props) => (props.size || 58) * 0.69}px;
	height: ${(props) => (props.size || 58) * 0.69}px;
	margin: ${(props) => (props.size || 58) * 0.14}px;
	border: ${(props) => Math.max(2, (props.size || 58) * 0.052)}px solid ${(props) => props.color || "#000"};
	border-radius: 50%;
	animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: ${(props) => props.color || "#000"} transparent transparent transparent;
`;

const Inner1 = styled(Inner)`
	animation-delay: -0.45s;
`;

const Inner2 = styled(Inner)`
	animation-delay: -0.3s;
`;

const Inner3 = styled(Inner)`
	animation-delay: -0.15s;
`;

export const SpinnerCenteredWrap = styled.div`
	animation: ${fadeIn} 2s;
	position: fixed;
	opacity: 1;
	top: 50%;
	left: 50%;
	margin-top: -30px;
	margin-left: -30px;
`;

interface SpinnerProps {
	text?: string;
	size?: number;
	color?: string;
}

/**
 * Show a circle loading spinner
 * @param text - Optional text to display below the spinner
 * @param size - Optional size in pixels (default: 58px)
 * @param color - Optional color for the spinner (default: #000)
 * @returns
 */
export const Spinner = ({ text, size, color }: SpinnerProps) => {
	return (
		<div className={"is-flex is-align-items-center is-flex-direction-column has-text-centered"}>
			<Outer size={size}>
				<Inner1 size={size} color={color}></Inner1>
				<Inner2 size={size} color={color}></Inner2>
				<Inner3 size={size} color={color}></Inner3>
				<Inner size={size} color={color}></Inner>
			</Outer>
			{typeof text === "string" && (
				<div className="py-2">
					<Trans.late>{text}</Trans.late>
				</div>
			)}
		</div>
	);
};

export default Spinner;
